import { h } from 'preact';
import SVGWrapper from '../../SvgWrapper';

function PlayIcon({ height = 60, width = 60, color = 'white', ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M12 1.80005C17.6334 1.80005 22.2 6.36674 22.2 12C22.2 17.6334 17.6334 22.2 12 22.2C6.36674 22.2 1.80005 17.6334 1.80005 12C1.80005 6.36674 6.36674 1.80005 12 1.80005ZM9.71196 7.4854C9.15425 7.11485 8.40005 7.51249 8.40005 8.18208V15.8836C8.40012 16.5399 9.12711 16.9399 9.68618 16.5961C10.6805 15.9848 12.0669 15.1553 13.1567 14.5887C14.1742 14.0598 15.5264 13.4513 16.5985 12.9856C17.2664 12.6955 17.2844 11.734 16.6278 11.4194C15.5505 10.9036 14.1822 10.227 13.1567 9.64575C12.0747 9.03252 10.7038 8.1444 9.71196 7.4854Z" fill={color} />
    </SVGWrapper>
  );
}

export default PlayIcon;
